import { useMemo, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import FileUpload from "../../../utils/FileUpload";
import "./settings.css";
import { useSelector } from "react-redux";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";

const ImportBulkData = () => {
  const slsRole = secureLocalStorage.getItem("role");
  const rawAccess = useSelector((state) => state.auth.access);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [collapseClass, setCollapseClass] = useState("");
  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(accessMap, "import", "view");
  const toggleCollapse = () => {
    if (collapseClass === "show") {
      setCollapseClass("");
    } else {
      setCollapseClass("show");
    }
    setIsCollapsed(!isCollapsed);
  };
  if (!hasViewAccess) {
    return <Unauthorized />;
  }
  return (
    <div className="all-content settingsContainer">
      <div className="all-table-holder importBulkDataContainer">
        <div id="importBulkData" className="importBulkDataWrap">
          <FileUpload role={slsRole} />
        </div>
      </div>
    </div>
  );
};

export default ImportBulkData;
